import React from 'react';
import jwtDecode from 'jwt-decode';
import { FILESTORE_URL } from '../../../../../config';
import PropertyEditor from './PropertyEditor';

class DetailsTab extends React.Component {
  constructor(props) {
    super(props);
    this.findZones = this.findZones.bind(this);
    this.findAreas = this.findAreas.bind(this);
    this.pictureUrl = this.pictureUrl.bind(this);
    this.savePicture = this.savePicture.bind(this);
    this.savePicturesOrder = this.savePicturesOrder.bind(this);
    this.deletePicture = this.deletePicture.bind(this);
    this.handleDeletePictureSuccess = this.handleDeletePictureSuccess.bind(this);
  }
  componentDidMount() {
    this.props.api.amenity.getObjects({
      propName: 'property_amenities',
      queryOptions: [['id', 'name', 'weight'], { order: { weight: 'asc' } }],
    });
    const clientId = JSON.parse(localStorage.getItem('currentUser')).client_id;
    const availableCountries = clientId === '3912abc1' || clientId === '12345678' ? ['ES'] : ['ID']; // TODO
    this.props.api.country.getObjects({
      propName: 'property_countries',
      queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { alpha_2: {in: availableCountries}} }],
    });
    if (this.props.objectData.id) {
      if (this.props.objectData.country.value[1]) {
        this.findZones(this.props.objectData.country.value[1]);
      }
      if (this.props.objectData.zone.value[1]) {
        this.findAreas(this.props.objectData.zone.value[1]);
      }
    }
  }
  render() {
    return (
      <div style={ {display: this.props.show ? 'block' : 'none'} }>
        <PropertyEditor
          { ...this.props }
          objectData={ this.props.objectData }
          onChangePresentation={ this.props.onChange.bind(this, 'Presentation') }
          onChangeLocation={ this.props.onChange.bind(this, 'Location') }
          onChangeFeatures={ this.props.onChange.bind(this, 'Features') }
          onChangePictures={ this.props.onChange.bind(this, 'Pictures') }
          findZones={ this.findZones }
          findAreas={ this.findAreas }
          countries={ this.props.api.getState('country').property_countries }
          zones={ this.props.api.getState('zone').property_zones }
          areas={ this.props.api.getState('area').property_areas }
          amenities={ this.props.api.getState('amenity').property_amenities }
          pictureUrl={ this.pictureUrl }
          onSavePicture={ this.savePicture }
          onSavePicturesOrder={ this.savePicturesOrder }
          onDeletePicture={ this.deletePicture }
          onDeletePictureSuccess={ this.handleDeletePictureSuccess }
          defaultLanguage={ this.props.defaultLanguage }
          availableLanguages={ this.props.availableLanguages } />
      </div>
    );
  }
  findZones(countryId) {
    this.props.api.zone.getObjects({
      propName: 'property_zones',
      queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { 'country.id': countryId } }],
    });
  }
  findAreas(zoneId) {
    this.props.api.area.getObjects({
      propName: 'property_areas',
      queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { 'zone.id': zoneId } }],
    });
  }

  savePicture(editedPicture) {
    this.props.api.property.savePicture({ propertyId: this.props.objectData.id, picture: editedPicture });
  }
  savePicturesOrder(pictures) {
    this.props.api.property.setData({ uploadSuccess: false });
    this.props.api.property.postData({ url: '/', data: { properties: [{ id: this.props.objectData.id, pictures }] } });
  }
  deletePicture(pictureId) {
    this.props.api.property.deletePicture({ propertyId: this.props.objectData.id, pictureId });
  }
  handleDeletePictureSuccess(pictures) {
    this.props.api.property.setData({ deletePictureSuccess: false });
    this.props.onChange('Pictures', 'pictures', { value: pictures });
  }

  pictureUrl(picture, type) {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    const fileId = picture[type] && picture[type].value ? picture[type].value.id : null;
    const fileName = picture[type] && picture[type].value ? picture[type].value.name : null;
    if (fileId && fileName) {
      return `${FILESTORE_URL}/${decoded.client_id}/properties-files/${this.props.objectData.id}/${fileId}/${fileName}`;
    } else {
      return '';
    }
  }
};

export default DetailsTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/DetailsTab.jsx